
      import API from "!../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../style-loader/dist/runtime/singletonStyleDomAPI.js";
      
      import setAttributes from "!../../../../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../../../css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../../source-map-loader/dist/cjs.js!./BorderScroller.css";
      
      

var options = {};

;
options.setAttributes = setAttributes;
options.insert = function addToWindowObject(element) {
            const _window = typeof window !== 'undefined' ? window : {}
            _window['hfBundleStyles'] = element
          };
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../../postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../../source-map-loader/dist/cjs.js!./BorderScroller.css";
       export default content && content.locals ? content.locals : undefined;
